import { useCallback, useState } from 'react';

import { useIntl } from 'react-intl';

import Grid from '@mui/material/Grid2';

import PageLayout from 'src/components/PageLayout';

import messages from './messages';
import Tutorials from './components/Tutorials';
import FieldCategories from './components/FieldCategories';

const navTabs: Array<{ value: UCM.SetupStatusType; label: string }> = [
  {
    value: 'tutorial',
    label: 'Tutorial',
  },
  {
    value: 'field_category',
    label: 'Additional Field',
  },
];

export default function SetupPage() {
  const { formatMessage } = useIntl();

  const [activeTab, setActiveTab] = useState<UCM.SetupStatusType>(
    navTabs[0].value,
  );

  const handleActiveTabChange = useCallback((tab: UCM.SetupStatusType) => {
    setActiveTab(tab);
  }, []);

  return (
    <PageLayout
      tabs={navTabs}
      iconName="setup"
      activeTab={activeTab}
      title={formatMessage(messages.title)}
      onActiveTabChange={handleActiveTabChange}
    >
      <Grid mt={1}>
        {activeTab === 'tutorial' ? <Tutorials /> : <FieldCategories />}
      </Grid>
    </PageLayout>
  );
}
